import {pgettext} from "@/utils/translate";

export const StartTriageColor = {
  RED: 'RED', YELLOW: 'YELLOW', GREEN: 'GREEN', BLACK: 'BLACK',
};

export const StartTriageColorLabel = {
  RED: pgettext('start_triage_color', 'red'),
  YELLOW: pgettext('start_triage_color', 'yellow'),
  GREEN: pgettext('start_triage_color', 'green'),
  BLACK: pgettext('start_triage_color', 'black'),
}

export const InjurySeverity = {
  MINOR: 'MINOR', MODERATE: 'MODERATE', SEVERE: 'SEVERE', DECEASED: 'DECEASED', UNINJURED: 'UNINJURED',
};

export const InjurySeverityLabel = {
  MINOR: pgettext('injury_severity_level', 'minor'),
  MODERATE: pgettext('injury_severity_level', 'moderate'),
  SEVERE: pgettext('injury_severity_level', 'severe'),
  DECEASED: pgettext('injury_severity_level', 'deceased'),
  UNINJURED: pgettext('injury_severity_level', 'uninjured'),
}


export const Priority = {
  I: 'I', II: 'II', III: 'III', IV: 'IV',
};


export const PriorityLabel = {
  I: pgettext('transport_priority', 'I'),
  II: pgettext('transport_priority', 'II'),
  III: pgettext('transport_priority', 'III'),
  IV: pgettext('transport_priority', 'IV'),
}

export const PRIORITY_COLOR_CONVERT_DICT = {
  'I': StartTriageColor.RED,
  'II': StartTriageColor.YELLOW,
  'III': StartTriageColor.GREEN,
  'IV': StartTriageColor.BLACK,
}

export function convertPriorityToColor(priority) {
  return PRIORITY_COLOR_CONVERT_DICT[priority]
}

export const COLOR_INJURY_LEVEL_CONVERT_DICT = {
  'GREEN': InjurySeverity.MINOR,
  'YELLOW': InjurySeverity.MODERATE,
  'RED': InjurySeverity.SEVERE,
  'BLACK': InjurySeverity.DECEASED,
}

export function convertPriorityToInjurySeverity(priority) {
  if (priority) {
    const color = convertPriorityToColor(priority)
    return COLOR_INJURY_LEVEL_CONVERT_DICT[color]
  }
  return InjurySeverity.UNINJURED

}

export const HpoWorkplaceMode = {
  DISPATCHING: 'DISPATCHING', CONTACT_POINT: 'CONTACT_POINT', PHC: 'PHC', TRANSPORT: 'TRANSPORT'
}


export const HpoBodyStatus = {
  AT_SCENE: 1,
  IN_TRANSPORT: 2,
  IN_HOSPITAL: 3,
  RELEASED: 4,
  TRANSPORT_PENDING: 5,
  TRANSPORT_READY: 6,
}

export const HpoBodyStatusLabel = {
  [HpoBodyStatus.AT_SCENE]: pgettext('hpo_body_status', 'at scene'),
  [HpoBodyStatus.IN_TRANSPORT]: pgettext('hpo_body_status', 'in transport'),
  [HpoBodyStatus.IN_HOSPITAL]: pgettext('hpo_body_status', 'in hospital'),
  [HpoBodyStatus.RELEASED]: pgettext('hpo_body_status', 'released'),
  [HpoBodyStatus.TRANSPORT_PENDING]: pgettext('hpo_body_status', 'transport pending'),
  [HpoBodyStatus.TRANSPORT_READY]: pgettext('hpo_body_status', 'transport ready'),
}

export const HpoTransportStatus = {
  DRAFT: 1,
  DISP_PENDING: 2,
  HOSPITAL_PENDING: 3,
  ON_WAY: 4,
  FINISHED: 5,
  TERMINATED: 6,
  READY: 7,
}

export const HpoTransportStatusLabel = {
  [HpoTransportStatus.DRAFT]: pgettext('hpo_patient_transport_status', 'draft'),
  [HpoTransportStatus.DISP_PENDING]: pgettext('hpo_patient_transport_status', 'dispatching pending'),
  [HpoTransportStatus.HOSPITAL_PENDING]: pgettext('hpo_patient_transport_status', 'hospital pending'),
  [HpoTransportStatus.ON_WAY]: pgettext('hpo_patient_transport_status', 'on way'),
  [HpoTransportStatus.FINISHED]: pgettext('hpo_patient_transport_status', 'finished'),
  [HpoTransportStatus.TERMINATED]: pgettext('hpo_patient_transport_status', 'terminated'),
  [HpoTransportStatus.READY]: pgettext('hpo_patient_transport_status', 'ready'),
}

export const HpoTransportDestinationRequestStatus = {
  PENDING: 1,
  ACCEPTED: 2,
  REFUSED: 3,
  CANCELED: 4,
}

export const HpoTransportDestinationRequestStatusLabel = {
  1: pgettext('hpo_patient_transport_destination_request_status', 'pending'),
  2: pgettext('hpo_patient_transport_destination_request_status', 'accepted'),
  3: pgettext('hpo_patient_transport_destination_request_status', 'refused'),
  4: pgettext('hpo_patient_transport_destination_request_status', 'canceled'),
}

export const WORKPLACE_TYPE = {
  ZOS: 'zos', CONTACT_POINT: 'contact_point', HZS: 'hzs',
}

export const HpoServiceType = {
  EMS: 1,
  FIRE_DEPT: 2,
  POLICE_DEPT: 3,
  MEDICAL_FACILITY: 4,
};

export const HpoServiceTypeLabel = {
  [HpoServiceType.EMS]: pgettext('hpo_service_type', 'EMS'),
  [HpoServiceType.FIRE_DEPT]: pgettext('hpo_service_type', 'Fire department'),
  [HpoServiceType.POLICE_DEPT]: pgettext('hpo_service_type', 'Police department'),
  [HpoServiceType.MEDICAL_FACILITY]: pgettext('hpo_service_type', 'Medical facility'),
};

export const HpoRole = {
  VLS: 1,
  EVAC_MANAGER: 2,
  KOPIS: 3,
  FIREMAN: 4,
  IOS: 5,
  POLICEMAN: 6,
  CONTACT_POINT: 7,
  ZOS: 8,
  PHC: 9,
  VIEWER: 10,
  HOSPITAL_SCREEN: 11,
  ER: 12,
  INFOLINE: 13
}

export const HpoRoleLabel = {
  1: pgettext('hpo_member', 'VLS'),
  2: pgettext('hpo_member', 'evacuation manager'),
  3: 'KOPIS',
  4: pgettext('hpo_member', 'fireman'),
  5: 'IOS',
  6: pgettext('hpo_member', 'policeman'),
  7: pgettext('hpo_member', 'contact point'),
  8: pgettext('hpo_member', 'ZOS'),
  9: pgettext('hpo_member', 'PHC'),
  10: pgettext('hpo_member', 'viewer'),
  11: pgettext('hpo_member', 'hospital screen'),
  12: pgettext('hpo_member', 'er'),
  13: pgettext('hpo_member', 'Infoline'),
}

// Mirrors HpoMemberObjectType.pin_status (graphene_types/hpo/member.py).
export const HpoPinStatus = {
  NOT_APPLICABLE: 'not_applicable',
  NONE: 'none',
  USED: 'used',
  EXPIRED: 'expired',
  SET: 'set',
}

export const HpoPinStatusLabel = {
  not_applicable: '—',
  none: pgettext('hpo_pin_status', 'no PIN'),
  used: pgettext('hpo_pin_status', 'used'),
  expired: pgettext('hpo_pin_status', 'expired'),
  // The PIN is stored hashed and can never be redisplayed, only replaced.
  set: '•••-•••-•••',
}

export const PatientModalTabs = {
  TIC: 'tic',
  TRIAGE: 'triage',
  TRANSPORT: 'transport',
  IDENTIFICATION: 'identification',
  HOSPITAL_RECORDS: 'hospitalRecords',
  IMAGES: 'images',
}

export const HpoAlertType = {
  SET_HOSPITAL: 1,
  REPLY_REQUEST: 2,
  READ: 3
}

export const HpoAlertTypeLabel = {
  1: pgettext('hpo_alret', 'set hospital'),
  2: pgettext('hpo_alret', 'reply request'),
  3: pgettext('hpo_alret', 'read'),
}

export const PoliceVerification = {
  UNVERIFIED: 1,
  VERIFIED: 2,
  UNABLE: 3,
}

export const PoliceVerificationLabel = {
  1: pgettext('police_verification', 'unverified'),
  2: pgettext('police_verification', 'verified'),
  3: pgettext('police_verification', 'unable'),
}

export const PoliceVerificationButtonLabel = {
  1: pgettext('police_verification_button_label', 'Not verified'),
  2: pgettext('police_verification_button_label', 'Verified by the police'),
  3: pgettext('police_verification_button_label', 'Data verification is not possible'),
}

export const HospitalType = {
  SPECIALISED: 'SPECIALISED', GENERAL: 'GENERAL',
};


export const HospitalTypeLabel = {
  SPECIALISED: pgettext('hospital_type', 'specialised'),
  GENERAL: pgettext('hospital_type', 'general'),
}